// Achievement counters shown on the home page. Figures confirmed by Sheba Digital Limited.
// Set value to null to display a dash instead of a number.
export const stats = [
  { label: 'Years of Experience', value: 10, suffix: '+' },
  { label: 'Projects Delivered', value: 100, suffix: '+' },
  { label: 'Clients', value: 30, suffix: '+' },
  { label: 'Team Members', value: 40, suffix: '+' },
  { label: 'Institutions Served', value: 1000, suffix: '+' },
  { label: 'Digital Transactions / Users', value: 1000000, suffix: '+' },
];
